import { Globe } from 'lucide-react';
import { Node } from '@xyflow/react';
import { EventCatalogResource, ExternalSystem as ExternalSystemType } from '../../types';

function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ');
}

type ExternalSystemNodeData = EventCatalogResource & {
  externalSystem: ExternalSystemType;
};

export type ExternalSystemNode = Node<ExternalSystemNodeData, 'external-system'>;

export default function ExternalSystem(props: ExternalSystemNode) {
  const { data, selected } = props;
  const { 
    version, 
    name, 
    summary 
  } = props.data.externalSystem;

  const mode = props.data.mode || 'simple';

  const nodeLabel = 'External';

  return (
    <div className={classNames(
        "w-full rounded-md min-h-[100px] border flex justify-start bg-white text-black",
        selected ? "border-pink-600 ring-2 ring-pink-500 shadow-lg" : "border-pink-400"
      )}>
        <div
          className={`bg-gradient-to-b from-pink-500 to-pink-700 relative flex items-center w-5 justify-center rounded-l-sm text-pink-100 border-r-[1px] border-pink-500`}
        >
          <Globe className="w-4 h-4 opacity-90 text-white absolute top-1" />
          {mode === 'full' && (
            <span
              className={"w-1/2 text-center absolute bottom-1 text-[8px] text-white font-bold uppercase tracking-[3px]"}
              style={{ transform: 'rotate(-90deg)' }}
            >
              {nodeLabel}
            </span>
          )}
        </div>
        <div className="p-1 min-w-60 max-w-[min-content]">
          <div className={classNames(mode === 'full' ? `border-b border-gray-200` : '')}>
            <span className="text-xs font-bold block pt-0.5 pb-0.5">{name}</span>
            <div className="flex justify-between">
              <span className="text-[10px] font-light block pt-0.5 pb-0.5">v{version}</span>
              {mode === 'simple' && (
                <span className="text-[10px] text-gray-500 font-light block pt-0.5 pb-0.5">{nodeLabel}</span>
              )}
            </div>
          </div>
          {mode === 'full' && (
            <div className="divide-y divide-gray-200">
              <div className="leading-3 py-1">
                <span className="text-[8px] font-light">{summary}</span>
              </div>
            </div>
          )}
        </div>
    </div>
  );
}